// TODO: GUI-4447 after migration from karma module resolution should be simplified. Karma task done on 09.09.2026, GUI-4447 can be taken into work.
import Highcharts from './runtime/highcharts-runtime';

// Vendor plugins must be imported after Highcharts core so that SeriesRegistry
// is fully initialized before each plugin's IIFE accesses seriesTypes.
import './plugins/vendor/highcharts-custom-events';
import './plugins/vendor/highcharts-roundedcorners';

export * from './components/index';
export * from './plugins/index';

// Allowed custom tags in Highcharts.
['ui-caption', 'ui-icon'].forEach((tag) => {
    Highcharts.AST.allowedTags.push(tag);
});

// Allowed custom attributes in Highcharts.
['state', 'glyph', 'position', 'color', 'bgcolor', 'layout', 'size'].forEach(
    (attr) => {
        Highcharts.AST.allowedAttributes.push(attr);
    }
);

// Re-export Highcharts runtime for consumers that need it.
// Type-only re-exports stay external (highcharts is a peerDependency) so
// dts-bundle-generator won't inline the full Highcharts type tree into index.d.ts.
export { Highcharts };
